module.exports = __webpack_public_path__ + "img/packageNew.d0b98f55.svg";